// extracted by mini-css-extract-plugin
module.exports = {"emojisWrapper":"Emojies-module__emojisWrapper","emoji":"Emojies-module__emoji","shake":"Emojies-module__shake","customText":"Emojies-module__customText"};